import Parse from "parse";

import type { Kanban_State } from "./Kanban_State";
import type { Ticket } from "./Ticket";
import type { Ticket_Kanban_State } from "./Ticket_Kanban_State";

type OD3_Tenant = Parse.Object;

export interface Ticket_Kanban_State_CurrentAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  state?: Kanban_State;
  tenant?: OD3_Tenant;
  ticket?: Ticket;
  ticketState?: Ticket_Kanban_State;
}

export class Ticket_Kanban_State_Current extends Parse.Object<Ticket_Kanban_State_CurrentAttributes> {
  static className: string = "OD3_Maintenance_Ticket_Kanban_State_Current";

  constructor(data?: Partial<Ticket_Kanban_State_CurrentAttributes>) {
    super("OD3_Maintenance_Ticket_Kanban_State_Current", data as Ticket_Kanban_State_CurrentAttributes);
  }

  get state(): Kanban_State | undefined {
    return super.get("state");
  }
  set state(value: Kanban_State | undefined) {
    super.set("state", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get ticket(): Ticket | undefined {
    return super.get("ticket");
  }
  set ticket(value: Ticket | undefined) {
    super.set("ticket", value);
  }
  get ticketState(): Ticket_Kanban_State | undefined {
    return super.get("ticketState");
  }
  set ticketState(value: Ticket_Kanban_State | undefined) {
    super.set("ticketState", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Ticket_Kanban_State_Current", Ticket_Kanban_State_Current);
